import { COLORS } from "@/theme/localTheme"
import TextField from "@mui/material/TextField"

interface ReadOnly {
  fieldName: string
  otherProps?: any
  value: string | any
  multiLine?: boolean
  fullWidth?: boolean
  row?: number
  highlightField?: boolean
}
const ReadOnlyTextField = ({ value, fieldName, multiLine, fullWidth, otherProps, row, highlightField }: ReadOnly) => {
  return (
    <>
      <TextField
        id="outlined-read-only-input"
        label={fieldName}
        placeholder={fieldName}
        defaultValue={value}
        multiline={multiLine}
        fullWidth={fullWidth}
        rows={row}
        InputProps={{
          readOnly: true,
        }}
        InputLabelProps={{
          style: { color: "rgba(255, 255, 255, 0.7)" },
          shrink: true,
        }}
        sx={{
          "& .MuiOutlinedInput-input": {
            color: highlightField ? COLORS.textWhite : "rgba(255, 255, 255, 0.7)",
          },
          "& fieldset": {
            borderColor: highlightField ? COLORS?.adminAppPrimaryBrandColor : COLORS?.adminAppTextPrimary,
          },
          "&:hover fieldset": {
            borderColor: highlightField ? COLORS?.adminAppPrimaryBrandColor : COLORS?.adminAppTextPrimary,
          },
          "& .MuiInputBase-root.Mui-focused fieldset": {
            "&:hover fieldset": {
              borderColor: highlightField ? COLORS?.adminAppPrimaryBrandColor : COLORS?.adminAppTextPrimary,
            },
            borderColor: highlightField ? COLORS?.adminAppPrimaryBrandColor : COLORS?.adminAppTextPrimary,
          },
          "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline ": {
            borderColor: highlightField ? COLORS?.adminAppPrimaryBrandColor : COLORS?.adminAppTextPrimary,
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "rgba(255, 255, 255, 0.7)",
          },
          "& .MuiInputBase-root.MuiOutlinedInput-root": {
            backgroundColor: highlightField ? COLORS?.adminAppPrimaryBrandColorTransluscentPlus : "",
          },
        }}
        {...otherProps}
      />
    </>
  )
}

export default ReadOnlyTextField
